import urls from './urls';
import Images from '../themes/subsets/tellUsAboutYourselfApiImages';
import { MEMBER_TYPES_REGISTER } from '../constants/memberTypesRegister';
import axios from 'axios';
import { getLangQueryParams } from 'redhotpie-shared-lib/functions/utils';

const sexResponseData = {
  success: true,
  statusCode: 200,
  message: 'Excute success',
  data: {
    items: [
      {
        ItemID: MEMBER_TYPES_REGISTER.MEN,
        ItemName: 'Men',
        icSrc: Images.icWhoMen,
        active: false,
      },
      {
        ItemID: MEMBER_TYPES_REGISTER.WOMEN,
        ItemName: 'Women',
        icSrc: Images.icWhoWoman,
        active: false,
      },
      {
        ItemID: MEMBER_TYPES_REGISTER.COUPLES,
        ItemName: 'Couple',
        icSrc: Images.icWhoCouple,
        active: false,
      },
      {
        ItemID: MEMBER_TYPES_REGISTER.COUPLES_FF,
        ItemName: 'Couple FF',
        icSrc: Images.icWhoCoupleFF,
        active: false,
      },
      {
        ItemID: MEMBER_TYPES_REGISTER.COUPLES_MM,
        ItemName: 'Couple MM',
        icSrc: Images.icWhoCoupleMM,
        active: false,
      },
      {
        ItemID: MEMBER_TYPES_REGISTER.GROUPS,
        ItemName: 'Group',
        icSrc: Images.icWhoGroup,
        active: false,
      },
      {
        ItemID: MEMBER_TYPES_REGISTER.TV_CD,
        ItemName: 'TV/CD',
        icSrc: Images.icWhoTVCD,
        active: false,
      },
      {
        ItemID: MEMBER_TYPES_REGISTER.TRANS_WOMAN,
        ItemName: 'Trans Woman',
        icSrc: Images.icWhoTransWoman,
        active: false,
      },
      {
        ItemID: MEMBER_TYPES_REGISTER.TRANS_MAN,
        ItemName: 'Trans Man',
        icSrc: Images.icWhoTransMan,
        active: false,
      },
    ],
  },
};

const ethnicityResponseData = {
  success: true,
  statusCode: 200,
  message: 'Excute success',
  data: {
    items: [
      {
        ItemID: 'item_0',
        ItemName: 'Men',
        icSrc: Images.icWhoMen,
        active: false,
      },
      {
        ItemID: 'item_1',
        ItemName: 'Men',
        icSrc: Images.icWhoMen,
        active: false,
      },
      {
        ItemID: 'item_2',
        ItemName: 'Men',
        icSrc: Images.icWhoMen,
        active: false,
      },
      {
        ItemID: 'item_3',
        ItemName: 'Men',
        icSrc: Images.icWhoMen,
        active: false,
      },
      {
        ItemID: 'item_4',
        ItemName: 'Men',
        icSrc: Images.icWhoMen,
        active: false,
      },
      {
        ItemID: 'item_5',
        ItemName: 'Men',
        icSrc: Images.icWhoMen,
        active: false,
      },
      {
        ItemID: 'item_6',
        ItemName: 'Men',
        icSrc: Images.icWhoMen,
        active: false,
      },
      {
        ItemID: 'item_7',
        ItemName: 'Men',
        icSrc: Images.icWhoMen,
        active: false,
      },
      {
        ItemID: 'item_8',
        ItemName: 'Men',
        icSrc: Images.icWhoMen,
        active: false,
      },
    ],
  },
};

const bodyTypesResponseData = {
  success: true,
  statusCode: 200,
  message: 'Excute success',
  data: {
    isMore: false,
    items: [
      {
        ItemID: 'thin',
        ItemName: 'Thin',
        icSrc: Images.icWhoMen,
        active: false,
      },
      {
        ItemID: 'slim',
        ItemName: 'Slim',
        icSrc: Images.icBodyTypeSlim,
        active: false,
      },
      {
        ItemID: 'large',
        ItemName: 'Large',
        icSrc: Images.icBodyTypeLarge,
        active: false,
      },
      {
        ItemID: 'cuddly',
        ItemName: 'Cuddly',
        icSrc: Images.icBodyTypeCuddly,
        active: false,
      },
      {
        ItemID: 'average',
        ItemName: 'Average',
        icSrc: Images.icBodyTypeAverage,
        active: false,
      },
      {
        ItemID: 'athletic',
        ItemName: 'Athletic',
        icSrc: Images.icBodyTypeAthletic,
        active: false,
      },
    ],
  },
};
const heightResponseData = {
  success: true,
  statusCode: 200,
  message: 'Excute success',
  data: {
    isMore: false,
    items: [
      {
        ItemID: '166cm',
        ItemName: '166cm - 5ft 3in',
        active: false,
        // value: {
        //   valueCm: 170,
        //   valueFt: {feet: 5, inch: 7}
        // }
      },
      {
        ItemID: '167cm',
        ItemName: '167cm - 5ft 4in',
        active: false,
        // value: {
        //     valueCm: 170,
        //     valueFt: {feet: 5, inch: 7}
        // }
      },
      {
        ItemID: '168cm',
        ItemName: '168cm - 5ft 5in',
        active: false,
        // value: {
        //     valueCm: 168,
        //     valueFt: {feet: 5, inch: 5}
        // }
      },
      {
        ItemID: '169cm',
        ItemName: '169cm - 5ft 6in',
        active: false,
        // value: {
        //     valueCm: 170,
        //     valueFt: {feet: 5, inch: 6}
        // }
      },
      {
        ItemID: '170cm',
        ItemName: '170cm - 5ft 7in',
        active: false,
        // value: {
        //     valueCm: 170,
        //     valueFt: {feet: 5, inch: 7}
        // }
      },
    ],
  },
};

const orientationResponseData = {
  success: true,
  statusCode: 200,
  message: 'Execute success',
  data: {
    isMore: false,
    items: [
      {
        ItemID: 'straight',
        ItemName: 'Straight',
        active: false,
      },
      {
        ItemID: 'experimental',
        ItemName: 'Experimental',
        active: false,
      },
      {
        ItemID: 'bi_curious',
        ItemName: 'Bi-Curious',
        active: false,
      },
      {
        ItemID: 'bisexual',
        ItemName: 'Bisexual',
        active: false,
      },
      {
        ItemID: 'gay',
        ItemName: 'Gay',
        active: false,
      },
      {
        ItemID: 'other',
        ItemName: 'Other',
        active: false,
      },
    ],
  },
};

class tellUsAboutYourselfApi {
  static loadSexTellUsAboutYourSelfData(params) {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_MEMBER_TYPE_DATA;
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios
      .get(url, { baseURL: urls.BASE_RHPURL, params: getLangQueryParams(params), headers: { isAnonymous: true } })
      .then(res => res);
  }

  static loadEthnicityTellUsAboutYourSelfData(params) {
    // this.restClient = new RestClient();
    const url = urls.GET_ETHNICITY_DATA;
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static loadRelationShip = () => {
    // this.restClient = new RestClient();
    const url = urls.GET_RELATION_SHIP;
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  };

  static loadBodyTypesData(params) {
    // this.restClient = new RestClient();
    const url = urls.GET_BODY_TYPE_DATA;
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }
  static loadHeightData(params) {
    // this.restClient = new RestClient();
    const url = urls.GET_HEIGHT_DATA;
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static loadOrientationData(params) {
    // this.restClient = new RestClient();
    const url = urls.GET_ORIENTATION_DATA;
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }
}

export default tellUsAboutYourselfApi;
